import PocketBase, { LocalAuthStore } from 'pocketbase'

function resolvePbUrl(): string {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname
    const isLocal = host === 'localhost' || host === '127.0.0.1'
    // Nicht-Localhost (Tailscale/Hetzner): origin nutzen, damit PocketBase-SDK
    // absolute URLs baut und nicht relative (z.B. /admin/surveys/new/api/...).
    // Browser löst /api auf Vite-Proxy auf, der an 127.0.0.1:8090 weiterleitet.
    if (!isLocal) return window.location.origin
  }
  return import.meta.env.VITE_PB_URL ?? ''
}

const url = resolvePbUrl()

// Public client — anonyme Reads
export const pb = new PocketBase(url)
pb.autoCancellation(false)

// Admin client — eigener LocalStorage-Key
export const pbAdmin = new PocketBase(url, new LocalAuthStore('pb_admin_auth'))
pbAdmin.autoCancellation(false)

export const pbBaseUrl = url

export function isAdminLoggedIn(): boolean {
  return (
    pbAdmin.authStore.isValid &&
    pbAdmin.authStore.record?.collectionName === '_superusers'
  )
}

export default pb
